import React from 'react';

import s from './Code.module.scss';

const Code = ({ children }) => {
  return <div className={s.codeContainer}></div>;
};

export default Code;
